import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { apiCaller } from '../query';
import { IResponseApi } from '@/types/apis/response';
import { AppPricingPlan, AppPricingType, Subscription } from '@/constants/enum';

interface IShopInfo {
  domain: string;
  appStatus: boolean;
  appPlan: AppPricingPlan;
  shopifyPlan: string;
  nameShop: string;
  cacheTime: number;
  showWatermark: boolean;
  email: string;
  pricingType: AppPricingType;
  subscription: Subscription;
  remainTrialDays: number;
}

export const initialState: IShopInfo = {
  domain: '',
  appStatus: true,
  appPlan: AppPricingPlan.Free,
  shopifyPlan: '',
  nameShop: '',
  cacheTime: 10,
  showWatermark: true,
  email: '',
  pricingType: AppPricingType.Unlimited,
  subscription: Subscription.Monthly,
  remainTrialDays: 0,
};

export const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    handleChangeShopSetting(state, action: PayloadAction<IShopInfo>) {
      Object.assign(state, action.payload);
    },
    handleChangeAppStatus(state, action: PayloadAction<boolean>) {
      state.appStatus = action.payload;
    },
    handleChangeCacheTime(state, action: PayloadAction<number>) {
      state.cacheTime = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      apiCaller.endpoints.getGeneralDetail.matchFulfilled,
      (state, action: PayloadAction<IResponseApi.GeneralDetail>) => {
        state.appStatus = action.payload.data.appStatus;
        state.domain = action.payload.data.shop;
        state.nameShop = action.payload.data.nameShop;
        state.appPlan = action.payload.data.appPlan;
        state.shopifyPlan = action.payload.data.shopifyPlan;
        state.cacheTime = action.payload.data.cacheTime;
        state.showWatermark = action.payload.data.showWatermark;
        state.email = action.payload.data.email;
        state.pricingType = action.payload.data.pricingType;
        state.subscription = action.payload.data.subscription;
        state.remainTrialDays = action.payload.data.remainTrialDays;
      },
    );
  },
});

export const appStatusSelector = createSelector(
  (state: RootState) => state.shop,
  (state) => state.appStatus,
);

export const showWatermarkSelector = createSelector(
  (state: RootState) => state.shop,
  (state) => state.showWatermark,
);

export const shopifyPlanSelector = createSelector(
  (state: RootState) => state.shop,
  (state) => state.shopifyPlan,
);

export const shopSelector = createSelector(
  (state: RootState) => state.shop,
  (state) => state,
);

export const { handleChangeShopSetting, handleChangeAppStatus, handleChangeCacheTime } = shopSlice.actions;
export default shopSlice;
